import react, { useEffect, useState } from "react";
import { Step, Stepper } from "@progress/kendo-react-layout";
import {
  getProcessesDetails,
  getProcessesStatusList,
} from "../../store/process/actions";
import { useDispatch, useSelector } from "react-redux";

const GG1SubWorkflowBlanket = ({ currentValue, ProcessID, setRenderProcessFlow, noa, evaluation, toGrade, fromGrade }) => {
  const {
    process,
    processStatusList,
    loadingProcessDetails,
    posting,
    postingResult,
    error,
  } = useSelector((state) => state.processReducer);
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [data, setData] = useState([]);
  const [processStatusesForGG1, setprocessStatusesForGG1] = useState([]);
  let dataRun = false;
  const handleChange = (e) => {
    // console.log("1212 stepper change ::: ", e, e.value, e.target.value);
    // setValue(e.value);
  };
  useEffect(() => {
    if (currentValue) {
      setRenderProcessFlow(true);
    } else {
      setRenderProcessFlow(false);
    }
  }, [currentValue]);
  useEffect(() => {
    if (ProcessID > 0 && currentValue) {
      dispatch(getProcessesStatusList(ProcessID));
    }
  }, [dispatch, ProcessID, currentValue]);
  useEffect(() => {
    if (processStatusList && processStatusList.length) {
      let newArray
      let recordsSeq = processStatusList.find((item) => item.id == 19)?.seq;

      // newArray = processStatusList.filter((item) => item.seq <= recordsSeq && item?.statusName?.includes("BBMR"));
      // newArray = processStatusList.filter((item) => item.seq <= recordsSeq && item?.parentId == 338);
      newArray = processStatusList.filter((item) => item.seq <= recordsSeq && item?.parentId == 338 && item?.statusName != "Admin Staff Review" && item?.statusName != "Admin Staff Routing");
      
      setprocessStatusesForGG1(newArray);
    }
  }, [processStatusList, evaluation, toGrade, fromGrade]);
  useEffect(() => {
    if (processStatusesForGG1 && processStatusesForGG1.length > 0) {
      setData(
        processStatusesForGG1.map((d,index) => {
          return { label: d?.statusName, text: `5.${index+1}`};
        })
      );
      // setTimeout(() => {
      let stepIndex = processStatusesForGG1.indexOf(
        processStatusesForGG1.find((d) => d.id === currentValue)
      );
      setValue(stepIndex);
      // }, 1000);
    }
  }, [processStatusesForGG1]);
  if (!data || data.length === 0) return null;
  return (
    <>
      <Stepper value={value} items={data} disabled />
    </>
  );
};
export default GG1SubWorkflowBlanket;
